import React from 'react';
import { Typography, Box, useTheme, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { tokens } from '../theme';

const Header = ({ title, subtitle, onGoBack }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box mb="30px">
      <Typography
        variant="h2"
        color={colors.grey[100]}
        fontWeight="bold"
        sx={{ mb: '5px', display: 'flex', alignItems: 'baseline', gap: 1 }}>
        {!!onGoBack && (
          <IconButton onClick={onGoBack}>
            <ArrowBack />
          </IconButton>
        )}
        {title}
      </Typography>
      <Typography variant="h5" color={colors.greenAccent[400]}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
